<template>
  <header>
    <van-row>
      <!-- ✅ Условный рендеринг макетов -->

      <!-- МАКЕТ 1: Если есть кнопка "Назад" -->
      <template v-if="isBackNavigationAllowed">
        <van-col span="3" class="itserve-right top-menu-item">
          <BackButton />
        </van-col>
        <van-col span="15" class="itserve-left page-title-block">
          <h1 class="page-title" @click="goBack()">
            {{ $t("routes." + this.$route.name) }}
          </h1>
        </van-col>
      </template>

      <!-- МАКЕТ 2: Если кнопки "Назад" НЕТ -->
      <template v-else>
        <div class="no-back-button" style="display: contents">
          <!-- Если это главная страница Home, показываем иконку/стрелку -->
          <template v-if="$route.name === 'Home'">
            <van-col span="3" class="itserve-right top-menu-item">
              <span
                v-if="account"
                @click="goBackToAccounts"
                class="top-bar-item"
              >
                <arrow-left
                  class="itserve-menu-icon"
                  :fill-color="'rgb(6, 83, 134)'"
                />
              </span>
              <span v-else class="top-bar-item">
                <account
                  class="itserve-menu-icon"
                  :fill-color="appTheme === 'dark' ? '#0562ad' : '#ffffff'"
                ></account>
              </span>
            </van-col>
            <van-col span="15" class="itserve-left page-title-block">
              <h1 class="page-title">
                {{ $t("routes." + this.$route.name) }}
              </h1>
            </van-col>
          </template>

          <!-- Иначе (например, для LoginPassword) показываем центрированный заголовок -->
          <template v-else>
            <van-col span="18" class="itserve-center page-title-block">
              <h1 class="page-title">
                {{ $t("routes." + this.$route.name) }}
              </h1>
            </van-col>
          </template>
        </div>
      </template>

      <!-- Иконки справа -->
      <van-col span="3" class="itserve-left top-menu-item top-bar-icon-bell">
        <router-link :to="{ name: 'Notifications' }" class="top-bar-item">
          <template v-if="notificationsCount > 0">
            <van-badge
              :content="notificationsCount > 99 ? '99+' : notificationsCount"
              class="notifications-badge"
            >
              <bell
                :fill-color="appTheme === 'dark' ? '#fbc02d' : '#ffffff'"
                class="itserve-menu-icon"
              />
            </van-badge>
          </template>
          <template v-else>
            <bell
              :fill-color="appTheme === 'dark' ? '#fbc02d' : '#ffffff'"
              class="itserve-menu-icon"
            />
          </template>
        </router-link>
      </van-col>
      <van-col class="itserve-left top-menu-item" span="3">
        <router-link :to="{ name: 'Settings' }" class="top-bar-item">
          <cog
            class="itserve-menu-icon blue-icon-color"
            :fill-color="appTheme === 'dark' ? '#0562ad' : '#ffffff'"
          />
        </router-link>
      </van-col>
    </van-row>
  </header>
</template>

<script>
import BackButton from "@/components/template/BackButton";
import goBack from "@/mixins/go-back";
import Badge from "vant/lib/badge/index";
import Bell from "vue-material-design-icons/Bell";
import Cog from "vue-material-design-icons/Cog";
import Account from "vue-material-design-icons/Account";
import ArrowLeft from "vue-material-design-icons/ArrowLeft";

export default {
  mixins: [goBack],
  name: "AppHeader",
  computed: {
    isBackNavigationAllowed() {
      if (this.$route.meta.hideBackButton) {
        return false;
      }
      const nonBackRoutes = ["AccountsListPage", "Home"];
      return !nonBackRoutes.includes(this.$route.name);
    },
    account() {
      return this.$store.state.Auth.account;
    },
    notificationsCount() {
      return this.$store.state.Notifications.unreadNotifications;
    },
    appTheme() {
      return this.$store.state.Auth.appTheme;
    },
  },
  created() {
    this.$store.dispatch("Notifications/getCountOfUnreadNotifications");
  },
  methods: {
    goBackToAccounts() {
      this.$router.push({ name: "AccountsListPage" });
    },
  },
  components: {
    BackButton,
    VanBadge: Badge,
    Cog,
    Bell,
    Account,
    ArrowLeft,
  },
};
</script>

<style scoped>
@import "../../../node_modules/vant/lib/badge/index.css";
.top-bar-item {
  position: relative;
  top: 7px;
}
.page-title {
  color: rgb(6, 83, 134) !important;
}
.page-title-block {
  text-align: left;
  padding-left: 15px;
}

/* Новый стиль для центрирования заголовка, когда нет кнопки назад */
.no-back-button .page-title-block {
  text-align: center;
  padding-left: 0;
}
</style>
